// @flow
import React from 'react'
import * as olEventsCondition from 'ol/events/condition'
import OlStyleStroke from 'ol/style/Stroke'
import OlStyle from 'ol/style/Style'
import OlInteractionDragBox from 'ol/interaction/DragBox'
import TextField from '@material-ui/core/TextField'
import type { IdentifyType } from '../../er2_map_userlayers/js/reducers/identify'
import OlMap from './ol_map'
import MapHistory from './map_history'
import Identify from './identify'

export type ButtonType = {
    className: string,
    name: string,
    onClick: Function
}

type PropsType = {
    buttons: ButtonType[],
    identify: IdentifyType,
    map: OlMap,
    mapToolbarPanelClosed: boolean,
    onIdentify: Function,
    onIdentifyHandled: Function,
    onMapToolbarButtonClicked: Function,
    theme?: {},
}

type StateType = {
    hasHistoryPrev: boolean,
    hasHistoryNext: boolean,
}

const styles = {
    button: {
        margin: '0px 6px',
        paddingBottom: '8px',
        verticalAlign: 'bottom',
    },
    active: {
        opacity: 'inherit',
    },
    inactive: {
        opacity: 0.4,
    },
}

class MapToolbar extends React.Component<PropsType, StateType> {
    mapHistory: MapHistory

    constructor(props) {
        super(props)
        this.identify = new Identify(props.map, props.onIdentify)
        this.state = {
            hasHistoryNext: false,
            hasHistoryPrev: false,
        }
    }

    componentWillReceiveProps(nextProps: PropsType, nextContext) {
        if (!this.mapHistory && nextProps.map) {
            this.addMapHistory(nextProps.map)
        }
        this.identify.processIdentify(nextProps)
    }

    addMapHistory(map) {
        const historyChanged = (() => {
            this.setState({
                hasHistoryPrev: this.mapHistory.hasHistoryPrev(),
                hasHistoryNext: this.mapHistory.hasHistoryNext(),
            })
        })
        this.mapHistory = new MapHistory(map, historyChanged)
    }

    render() {
        const zoomIn = () => {
            // Add interaction
            if (this.state.interaction) {
                this.props.map.removeInteraction(this.state.interaction)
            }

            const interaction = new OlInteractionDragBox({
                condition: olEventsCondition.always,
                style: new OlStyle({
                    stroke: new OlStyleStroke({
                        color: [0, 0, 255, 1],
                    }),
                }),
            })

            // Map events
            interaction.on('boxend', () => {
                if (interaction) {
                    const extent = interaction.getGeometry().getExtent()
                    this.props.map.setExtent(extent)
                    this.props.map.removeInteraction(interaction)
                }
            })
            this.props.map.addInteraction(interaction)
            this.setState({ interaction })
        }

        if (this.props.map && this.props.buttons.length) {
            this.props.buttons.forEach((b) => {
                b.onClick = () => {
                    this.props.onMapToolbarButtonClicked(b.name)
                    if (b.name === 'zoomIn') {
                        zoomIn()
                    } else if (b.name === 'nextExtent') {
                        this.mapHistory.historyNext()
                    } else if (b.name === 'prevExtent') {
                        this.mapHistory.historyPrevious()
                    } else if (b.name === 'identify') {
                        this.identify.identify()
                    }
                }
                let iconstyle = styles.button
                if (b.name === 'prevExtent') {
                    if (!this.mapHistory || !this.state.hasHistoryPrev) iconstyle = { ...iconstyle, ...styles.inactive }
                } else if (b.name === 'nextExtent') {
                    if (!this.mapHistory || !this.state.hasHistoryNext) iconstyle = { ...iconstyle, ...styles.inactive }
                }
                b.className = b.icon
                b.style = iconstyle
            })

            const classes = [this.props.theme.mapToolbarContainer]
            classes.push(this.props.mapToolbarPanelClosed ? this.props.theme.mapToolbarPanelClosed : this.props.theme.mapToolbarPanelOpen)

            const onChange = (b, e) => {
                if (b.name === 'zoomToAddress') {
                    if (e.key === 'Enter') {
                        this.props.map.zoomToAddress(e.target.value)
                        e.preventDefault()
                    }
                }
            }
            return (
                <div className={classes.join(' ')}>
                    {this.props.buttons.map((b) => {
                        if (b.jsx) return (b.jsx(e => onChange(b, e)))
                        return (
                            <span key={b.name} role="button" tabIndex="0" className={b.className} onClick={b.onClick} style={b.style} />
                        )
                    })}
                </div>
            )
        }
        return (null)
    }
}

MapToolbar.defaultProps = {
    buttons: [
        {
            icon: 'fa fa-search-plus',
            name: 'zoomIn',
        }, {
            icon: 'fa fa-chevron-circle-left',
            name: 'prevExtent',
        }, {
            icon: 'fa fa-chevron-circle-right',
            name: 'nextExtent',
        }, {
            icon: 'fa fa-info-circle',
            name: 'identify',
        }, {
            name: 'zoomToAddress',
            jsx: onChange => (<TextField
                key="zoomToAddress"
                style={{ marginLeft: '20px', marginRight: '10px', width: '80px', height: '40px' }}
                label="Zoom to:"
                onKeyPress={(e) => { onChange(e) }}
            />),
        },
    ],
    onMapToolbarButtonClicked: (buttonName) => {
        console.warn(`${buttonName} clicked`)
    },
    theme: {},
}

export default MapToolbar
